<template>
  <v-card
    elevation="0"
    class="rounded-lg pa-0 w-100 h-100"
  >
    <v-card-title class="px-3 py-2 d-flex justify-space-between">
      <h5 class="text-caption mr-1 font-weight-bold">Customer Details</h5>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-subtitle class=" d-flex justify-center algin-center">
      <v-row no-gutters>
        <v-col cols="12" class="pb-1" v-if="dataObj.customer_name">
          <BaseLabel
            icon="mdi-account"
            :text="dataObj.customer_name"
            label="customer Name"
            tooltipLabel="customer Name"
          />
        </v-col>
        <v-col cols="6" class="pb-1" v-if="dataObj.customer_availability_window">
          <BaseLabel
            icon="mdi-timer"
            :text="dataObj.customer_availability_window"
            label="Delivery windows"
            tooltipLabel="Delivery windows"
          />
        </v-col>
        <v-col cols="6" class="pb-1" v-if="dataObj.customer_code">
          <BaseLabel
            icon="mdi-timer"
            :text="dataObj.customer_code"
            label="Customer Code"
            tooltipLabel="Customer Code"
          />
        </v-col>
        <v-col cols="6" class="pb-1" v-if="dataObj.contact_email">
          <BaseLabel
            icon="mdi-email"
            :text="dataObj.contact_email"
            label="Customer Email"
            tooltipLabel="Customer Email"
          />
        </v-col>
        <v-col cols="6" class="pb-1" v-if="dataObj.customer_number">
          <BaseLabel
            icon="mdi-phone"
            :text="dataObj.customer_number"
            label="Contact No"
            tooltipLabel="Contact No"
          />
        </v-col>
      </v-row>
    </v-card-subtitle>
  </v-card>
</template>

<script>
import TripTooltipWithIcon from "@/components/ModuleBasedComponents/Trip/TripTooltipWithIcon.vue";
import BaseLabel from "@/components/BaseComponents/BaseLabel.vue";
export default {
  components: {
    TripTooltipWithIcon,
    BaseLabel,
  },
  props: {
    dataObj: {
      required: true,
    },
  },
};
</script>